<template>
    <b-container fluid>
        <hr/>
        <h3>Subscribers</h3>
        <hr/>
        <b-button-group>
            <v-btn v-b-modal.create_subscriber_modal :style="primaryStyle" :loading="loadingCreate"
                   :disabled="loadingCreate">New subscriber
            </v-btn>
        </b-button-group>
        <hr/>
        <v-skeleton-loader
                :loading="this.loadingIndex"
                transition='fade-transition'
                ref="skeleton"
                type="table"
                class="mx-auto"
                width="100%">
            <b-table striped :items="subscribers"
                     :fields="[
                     {key: 'id', sortable: true},
                     {key: 'name', sortable: true},
                     {key: 'event_name', sortable: true},
                     {key: 'active', sortable: true},
                     {key: 'priority', sortable: true},
                     {key: 'queueCategory', sortable: true},
                     'edit',
                     'edit_blocks',
                     'make_copy',
                     'delete'
                ]">
                <template slot="edit" slot-scope="data">
                    <b-button @click="editSubscriber(data.item)" variant="primary">Edit</b-button>
                </template>
                <template slot="edit_blocks" slot-scope="data">
                    <b-button @click="editSubscriberBlocks(data.item)" variant="secondary">Edit blocks</b-button>
                </template>
                <template slot="make_copy" slot-scope="data">
                    <b-button @click="makeCopyOfSubscriber(data.item)" variant="secondary">Make copy</b-button>
                </template>
                <template slot="delete" slot-scope="data">
                    <b-button @click="deleteSubscriber(data.item)" variant="danger">Delete</b-button>
                </template>
            </b-table>
        </v-skeleton-loader>

        <create v-bind:event_options="event_options"
                @subscriber-created="SubscriberCreated"
                @change-create-loading="loadingCreate = !loadingCreate">
        </create>

        <edit v-bind:selected_subscriber="to_edit_subscriber"
              @subscriber-edited="SubscriberEdited"
              @show-loading-pop-up="showLoadingPopUp"
              @reset-loading-pop-up="resetLoadingPopUp">
        </edit>

        <make-copy v-bind:subscriber_id="to_edit_subscriber_id"
                   v-bind:subscriber_name="to_edit_subscriber_name"
                   v-bind:event_options="event_options"
                   @subscriber-created="SubscriberCreated"
                   @show-loading-pop-up="showLoadingPopUp"
                   @reset-loading-pop-up="resetLoadingPopUp">
        </make-copy>

        <block-editor v-bind:id="to_edit_subscriber_id"
                      v-bind:name="to_edit_subscriber_name"
                      v-bind:currentBlocks="to_edit_subscriber_blocks"
                      v-bind:subscriber-history="to_edit_subscriber_history"
                      @show-loading-pop-up="showLoadingPopUp"
                      @reset-loading-pop-up="resetLoadingPopUp">
        </block-editor>
    </b-container>
</template>

<script>
    import SubscriberRepository from '../../repositories/subscriber.repository';
    import Create from './Create.vue';
    import Edit from './Edit.vue';
    import BlockEditor from './Blocks/BlockEditor.vue';
    import MakeCopy from "./MakeCopy";

    export default {
        components: {
            Create,
            Edit,
            BlockEditor,
            MakeCopy
        },
        data() {
            return {
                subscribers: [],
                events: [],
                to_edit_subscriber: SubscriberRepository.blankSubscriber(),
                to_edit_subscriber_id: -1,
                to_edit_subscriber_name: '',
                to_edit_subscriber_blocks: [],
                to_edit_subscriber_history: [],
                loadingIndex: false,
                loadingCreate: false,
            }
        },
        created() {
            this.loadingIndex = true;
            SubscriberRepository.getIndexData().then(res => {
                if (res.data.success) {
                    this.subscribers = res.data.subscribers;
                    this.events = res.data.events;
                } else window.console.log('Looks like something went wrong...');
                this.loadingIndex = false;
            }).catch(error => {
                this.loadingIndex = false;
            });
        },
        methods: {
            showLoadingPopUp(text) {
                this.$emit('show-loading-pop-up', text);
            },
            resetLoadingPopUp() {
                this.$emit('reset-loading-pop-up');
            },
            SubscriberCreated(sub) {
                this.subscribers.push(sub);
            },
            SubscriberEdited(sub) {
                this.subscribers.forEach(s => {
                    if (s.id === sub.id) Object.assign(s, sub);
                });
            },
            makeCopyOfSubscriber(sub) {
                this.to_edit_subscriber_id = sub.id;
                this.to_edit_subscriber_name = sub.name;
                this.$bvModal.show('make_copy_subscriber_modal');
            },
            editSubscriber(sub) {
                this.to_edit_subscriber = Object.assign({}, sub);
                this.$bvModal.show('edit_subscriber_modal');
            },
            editSubscriberBlocks(sub) {
                this.to_edit_subscriber_id = sub.id;
                this.to_edit_subscriber_name = sub.name;

                this.$emit('show-loading-pop-up', 'Loading the blocks to edit.');
                SubscriberRepository.getBlocks(sub.id).then(res => {
                    this.$emit('reset-loading-pop-up');
                    if (res.data.success) {
                        let blocks = res.data.blocks;

                        for (let i = 0; i < blocks.length; i++) { // assign unique key to each block for v-for
                            blocks[i].id = i;
                        }

                        this.to_edit_subscriber_blocks = blocks;
                        this.$bvModal.show('edit_subscriber_block_editor_modal');
                    }
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                    this.$bvToast.toast('Looks like something went wrong while loading the blocks.', {
                        title: `Load block error.`,
                        variant: 'danger',
                        solid: true
                    });
                });
                SubscriberRepository.getSubscriberHistory(sub.id).then(res => {
                    if (res.data.success) {
                        this.to_edit_subscriber_history = res.data.history;
                    }
                });
            },
            deleteSubscriber(sub) {
                this.$emit('show-loading-pop-up', 'Deleting the selected subscriber.');
                SubscriberRepository.delete(sub.id).then(res => {
                    this.$emit('reset-loading-pop-up');
                    // Status 204 means no content, which is the response we would expect when deleting a record.
                    if (res.status === 204) {
                        // Remove the subscriber from the local list to reflect the deletion.
                        this.subscribers = this.subscribers.filter(s => s.id !== sub.id);
                        // Notify the user.
                        this.$bvToast.toast(`Subscriber ${sub.name} successfully deleted.`, {
                            title: `Subscriber deleted.`,
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        // If the status is not 204 something must have gone wrong.
                        // So we notify the user with a toast.
                        this.$bvToast.toast('Looks like something went wrong while deleting a subscriber.', {
                            title: `Subscriber deletion error.`,
                            variant: 'danger',
                            solid: true
                        });
                    }
                }).catch(error => {
                    this.$emit('reset-loading-pop-up');
                    this.$bvToast.toast('Looks like something went wrong while deleting a subscriber.', {
                        title: `Subscriber deletion error.`,
                        variant: 'danger',
                        solid: true
                    });
                });
            },
        },
        computed: {
            event_options() {
                return this.events.map(e => {
                    return {value: e.name, text: e.name};
                });
            }
        }
    }
</script>
